import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { useMutation } from "react-query";
import { useAuth } from "../../../hooks/useAuth";
import Datetime from "react-datetime";

const DepreciationTriggerModal = ({ show, onHide, onSuccess }) => {
  const { user, backendUrl } = useAuth();
  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const depreciationMutation = useMutation(
    data =>
      fetch(`${backendUrl}/api/depreciations/post-depreciations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(res => {
        if (!res.ok) throw new Error("Failed to trigger depreciation");
        return res.json();
      }),
    {
      onSuccess: () => {
        onSuccess?.();
        onHide();
      },
    }
  );

  // Function to check if a date is the last day of the month
  const isLastDayOfMonth = date => {
    const testDate = new Date(date);
    const nextDay = new Date(testDate);
    nextDay.setDate(testDate.getDate() + 1);
    return nextDay.getMonth() !== testDate.getMonth();
  };

  // Function to get the last day of the month for a given date
  const getLastDayOfMonth = date => {
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
  };

  const handleSubmit = e => {
    e.preventDefault();
    depreciationMutation.mutate({ currentDate });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="h5">Trigger Depreciation</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {depreciationMutation.error && (
            <Alert variant="danger">{depreciationMutation.error.message}</Alert>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Date (Last Day of Month Only)</Form.Label>
            <Datetime
              dateFormat="MMM DD, YYYY"
              timeFormat={false}
              closeOnSelect={true}
              closeOnClickOutside={true}
              name="DateLog"
              inputProps={{
                className: `date-input form-control`,
                placeholder: "Select last day of month",
                readOnly: true,
              }}
              value={currentDate}
              isValidDate={current => {
                return isLastDayOfMonth(current.toDate());
              }}
              onChange={date => {
                const selectedDate = date.toDate();
                if (isLastDayOfMonth(selectedDate)) {
                  setCurrentDate(date.format("YYYY-MM-DD"));
                } else {
                  // Auto-select the last day of the selected month
                  const lastDay = getLastDayOfMonth(selectedDate);
                  setCurrentDate(lastDay.toISOString().split("T")[0]);
                }
              }}
            />
            <Form.Text className="text-muted">
              Only the last day of each month can be selected.
            </Form.Text>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            disabled={depreciationMutation.isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={depreciationMutation.isLoading}
          >
            {depreciationMutation.isLoading
              ? "Processing..."
              : "Trigger Depreciation"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DepreciationTriggerModal;
